module.exports = __webpack_public_path__ + "img/6.c42e048a.jpg";